import React from "react";
import { SheetProvider as SharedSheetProvider } from "@components/sheet-provider";
import { showNotification } from "../../Central/selectors";
import "./sheetRegistry";

export const SheetProvider: React.FC = () => {
	return (
		<SharedSheetProvider
			onPendingChangeWarning={(message) =>
				showNotification({ message, type: "warning" })
			}
		/>
	);
};
